import { render, staticRenderFns } from "./GerarSaldo.vue?vue&type=template&id=925773c8&scoped=true&"
import script from "./GerarSaldo.vue?vue&type=script&lang=js&"
export * from "./GerarSaldo.vue?vue&type=script&lang=js&"
import style0 from "./GerarSaldo.vue?vue&type=style&index=0&id=925773c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925773c8",
  null
  
)

export default component.exports